import type { JsonRecord } from '@/domain/entities/property-schema';
import type { AttributeNode } from '@/types/schemas';
import { LeafInput } from './LeafInput';

export function NodeEditor(props: {
  node: AttributeNode;
  path: string;
  value: unknown;
  onChange: (path: string, value: unknown) => void;
}) {
  const { node, path, value, onChange } = props;

  if (node.type === 'object') {
    const objVal = typeof value === 'object' && value != null && !Array.isArray(value) ? (value as JsonRecord) : {};

    return (
      <div className="space-y-3 rounded-xl border p-3">
        <div className="text-sm font-medium">
          <span className="font-mono">{node.key}</span>
          <span className="text-muted-foreground ml-2 text-xs">object</span>
        </div>

        <div className="space-y-3">
          {(node.attributes ?? []).length === 0 ? (
            <div className="text-muted-foreground text-sm">No fields</div>
          ) : (
            (node.attributes ?? []).map((child) => {
              const childPath = `${path}.${child.key}`;
              const childValue = objVal[child.key];
              return (
                <NodeEditor key={childPath} node={child} path={childPath} value={childValue} onChange={onChange} />
              );
            })
          )}
        </div>
      </div>
    );
  }

  if (node.type === 'array') {
    return (
      <div className="text-muted-foreground rounded-xl border p-3 text-sm">
        Array editor not implemented for <span className="font-mono">{node.key}</span> yet.
      </div>
    );
  }

  // ✅ shared renderer for boolean/number/string
  return <LeafInput node={node} label={node.key} value={value} onChange={(next) => onChange(path, next)} />;
}
